import styled from 'styled-components';

const Wrapper = styled.section`
	.motif-progress-loader {
		position: absolute;
		top: 50%;
		left: 50%;
	}
	.motif-menu {
		.motif-icon-button {
			.motif-icon {
				svg {
					width: var(--px-20) !important;
					height: var(--px-20) !important;
				}
			}
		}
	}
	.add-workspace-section {
		display: flex;
		align-items: end;
	}
	.motif-menu-overlay-open {
		background: none !important;
	}
	.motif-toast {
		width: 35%;
		right: 1%;
		top: var(--px-70);
		left: unset;
		position: fixed;
		z-index: 1;
	}

	.workspace_menu {
		width: 80%;
		top: var(--px-60);
		background: var(--neutrals-bg-gradient1) !important;
		border: 1px solid var(--neutrals-200);
		box-shadow: 0px 4px 8px 0px rgba(35, 35, 47, 0.06),
			0px 16px 32px 0px rgba(35, 35, 47, 0.08) !important;
		.warning {
			color: var(--ui-text-error) !important;
		}
		.roleType {
			color: var(--ui-text-main);
		}		
		.motif-toast {
			width: 35%;
			right: 1%;
			top: var(--px-28);
			left: unset;
			position: fixed;
			z-index: 1;
		}
		.motif-progress-loader {
			position: absolute;
			top: 45%;
			left: 45%;
		}
		.motif-table {
			height: calc(100vh - var(--px-316)) !important;
			.ellipses {
				display: flex;
				color: var(--ui-text-main) !important;
			}
			.ag-row {
				border-bottom: none;
				.ag-cell-wrapper {
					display: grid;
					width: 100%;
				}
			}
			.ag-header-cell-text {
				font-size: var(--px-14) !important;
				font-weight: 400 !important;
				line-height: var(--px-20) !important;
				color: var(--neutrals-900);
			}
		}
		.header-wrapper {
			display: flex;
			justify-content: end;
			padding: 0 var(--spacing-x-large);
		}
		.footer_button {
			display: flex;
			justify-content: end;
			padding: var(--spacing-x-large);
			border-top: var(--border-width-small) solid var(--neutrals-100);
			.previousBtn {
				margin-right: var(--spacing-medium-large);
			}
		}
		.motif-menu-header-information {
			width: 95%;
		}
		.motif-breadcrumb-list {
			margin-bottom: 0;
		}
		.add-workspace {
			.motif-icon {
				svg {
					fill: none;
				}
			}
		}
		.mainwrapper {
			padding: var(--spacing-x-large) !important;
		}
	}

	.workspace_menuTable {
		width: 100% !important;
	}
	//pagination

	.pagerholder {
		margin: 0 auto;
		width: 100%;
		position: absolute;
		bottom: var(--px-0);
	}

	.sharepointWorkspace-paging {
		justify-content: flex-end;
		line-height: normal;
		min-width: auto !important;
		font-size: var(--px-14);
		background: var(--neutrals-bg-gradient1);
		border-top: 1px solid ${(props) => props.theme.color[`grey200`]};
	}

	.mainwrapper {
		overflow: hidden;
		padding-top: var(--spacing-xx-large);
		background: var(--neutrals-bg-gradient1);

		.message {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			height: calc(100vh - var(--px-194));

			&h5 {
				color: ${(props) => props.theme.color[`grey500`]};
			}
		}

		//heading
		.sharepointWorkspace {
			.pageheading {
				display: flex;
				padding: var(--px-20) 0;
				svg {
					min-width: var(--px-25) !important;
					min-height: var(--px-25) !important;
					margin-right: var(--spacing-medium-small);
				}

				h3 {
					margin: 0;
					line-height: var(--px-25);
				}
			}
		}

		//addon

		.add-on {
			display: flex;
			margin-right: auto;
			padding: 0 0 var(--spacing-x-large) 0;

			.adduser {
			}

			.search {
				width: var(--px-400);
				margin-right: auto;
			}
		}

		.norecord {
			height: calc(100vh - var(--px-316));
			display: inline-block;
			width: 100%;
			display: flex;
			justify-content: center;
			flex: 0 auto;
			align-items: center;
			font-size: var(--spacing-large);
			color: ${(props) => props.theme.color[`grey400`]};
		}

		.sharepointWorkspaceTable {
			overflow-y: auto;
			user-select: none;
			.motif-table {
				height: calc(100vh - var(--px-300)) !important;

				.ag-header-cell .ag-header-select-all {
					visibility: hidden;
				}

				.ag-body-viewport {
					&:after {
						content: none;
					}
				}
				.ag-root.ag-layout-normal {
					overflow-y: auto;
					width: 100%;
				}

				.ag-root.ag-layout-auto-height {
					display: block;
				}

				.ag-center-cols-viewport {
					overflow-x: hidden;
				}

				.ag-row {
					.ag-cell-value {
						a.groupname {
							width: 100%;
							display: inline-block;							
    						color: var(--blue-600);
    						font-weight: 400;

							.ellipses {
								display: flex;
								color: var(--blue-600) !important;
							}
						}
					}
				}

				.ag-row,
				.ag-row-hover {
					.ag-cell-wrapper {
						width: 100%;
						display: grid !important;
					}
				}

				.ag-cell,
				.ag-header-cell {
					display: block;

					.ag-header-cell-text {
						font-size: var(--px-14) !important;
						font-weight: 400 !important;
						line-height: var(--px-20) !important;
						color: var(--neutrals-900);
					}
				}

				.roleType.disabled,
				.roleType.disabled * {
					color: ${(props) => props.theme.color[`grey300`]}!important;
					fill: ${(props) => props.theme.color[`grey300`]};
				}
				.noptr {
					pointer-events: none;
				}
				.disabled {
					color: ${(props) => props.theme.color[`grey300`]}!important;
					fill: ${(props) => props.theme.color[`grey300`]};
				}

				.ag-row {
					border-bottom: none;
				}
				.roleType {
					display: inline-block;
					width: 100%;
					align-items: center;
					cursor: default;
					color: var(--ui-text-main) !important;
					line-height: var(--px-20);
					&.enable.icon {
						fill: ${(props) => props.theme.color[`black`]}!important;
					}
				}
			}

			.errorRow {
				color: ${(props) => props.theme.color[`red600`]} !important;
			}
		}

		.ag-body-horizontal-scroll {
			overflow: auto;
		}

		.ag-layout-normal {
			&::-webkit-scrollbar {
				width: var(--px-6);
			}
			&::-webkit-scrollbar-track {
				width: var(--px-6);
			}
			&::-webkit-scrollbar-thumb {
				width: var(--px-6);
				/* cursor: pointer; */
			}
			&::-webkit-scrollbar-thumb:hover {
			}
		}
	}
`;

export default Wrapper;
